module.exports = __webpack_public_path__ + "static/media/LOGO SL 2020.367e4acb.png";